import { Component, OnInit, HostListener, ElementRef } from '@angular/core';
import { ILoadedEventArgs, ChartTheme } from '@syncfusion/ej2-angular-charts';
import { Browser } from '@syncfusion/ej2-base';

import { OomphComponent } from '../oomph.component';

@Component({
  selector: 'sn-oom-dashboard',
  templateUrl: './oom-dashboard.component.html',
  styleUrls: ['./oom-dashboard.component.css', '../oomph.component.css']
})
export class OomDashboardComponent extends OomphComponent {

  public chartHeight:string;
  public new_users: Object[];
  public total_users: Object[];
  private chartHeightOffset: number = -180;

  ngOnInit() {
    this.oomphService.setCurrentView(this.oomphService.view_oom_dashboard);
    this.currentScreenSize.subscribe((size) => {
      this.chartHeight = window.innerHeight + this.chartHeightOffset + 'px';
    })

    this.generateTestData();
  }
  
  private months: string[] = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ];

  private generateTestData() {
    var today: Date = new Date(Date.now());
    this.new_users = [];
    for (var i = 0; i < 12; i++) {
      var new_user = { 'x': this.months[i] };
      if (i < today.getMonth()) {
        new_user['y'] = (i + 1);
      } else {
        new_user['y'] = 0;
      }
      this.new_users.push(new_user);
    }

    this.total_users = [];
    for (var i = 0; i < 12; i++) {
      var total_user = { 'x': this.months[i] };
      if (i < today.getMonth()) {
        total_user['y'] = (i + 1) * 2;
      } else {
        total_user['y'] = 0;
      }
      total_user['text'] = '$' + total_user['y'];
      this.total_users.push(total_user);
    }
    console.log(this.new_users);
    console.log(this.total_users);
  }

  //Initializing Primary X Axis
  public primaryXAxis: Object = {
      valueType: 'Category', interval: 1, majorGridLines: { width: 0 }
  };
  //Initializing Primary Y Axis
  public primaryYAxis: Object = {
      minimum: 0, maximum: 12, interval: 3, majorGridLines: { width: 0 },
      majorTickLines: { width: 0 }, lineStyle: { width: 0 }, labelStyle: { color: 'transparent' }
  };
  public total_marker: Object = { dataLabel: { visible: true, position: 'Top', font: { fontWeight: '600', color: 'white' } } };
  public new_marker: Object = { dataLabel: { visible: true, name: 'text', position: 'Top', font: { fontWeight: '600', color: 'white' } } }
  public title: string = 'Fruit Consumption';
  public tooltip: Object = {
      enable: true,
      shared: true
  };
  public chartArea: Object = {
      border: {
          width: 0
      }
  };
  public placement: boolean = false;
  public width: string = '100%';
  // custom code start
  public load(args: ILoadedEventArgs): void {
      let selectedTheme: string = location.hash.split('/')[1];
      selectedTheme = selectedTheme ? selectedTheme : 'Material';
      args.chart.theme = <ChartTheme>(selectedTheme.charAt(0).toUpperCase() + selectedTheme.slice(1)).replace(/-dark/i, "Dark");
  };

  public copyUrlToClipboard(element) {
    // var $temp = document.getElementById(element);
    // $("body").append($temp);
    // $temp.val($(element).text()).select();
    // document.execCommand("copy");
    // $temp.remove();
  }  
}


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/oomph/oom-dashboard/oom-dashboard.component.ts